import { styled } from 'styled-components';
import { Popover } from '@mui/material';

export const DetailsHeaderWrapper = styled.div<{ $wrap?: boolean }>`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  display: flex;
  padding: 20px;
  padding-right: 40px;
  flex-direction: row;
  flex-wrap: ${({ $wrap }) => ($wrap ? 'wrap' : 'nowrap')};
  min-width: 0;
  justify-content: space-between;
  gap: 15px;
  align-self: stretch;
  margin-top: 20px;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.text.primary};
  h1 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 143%;
    letter-spacing: 0.17px;
    margin: 0;
    margin-bottom: 6px;
  }
  p {
    font-weight: 400;
    letter-spacing: 0.15px;
    margin: 0;
  }
`;

export const StyledPopover = styled(Popover)`
  box-shadow: none;
  border: none;
  border-radius: 8px;
`;
